import { render, staticRenderFns } from "./comingSoon.vue?vue&type=template&id=84ebd374"
import script from "./comingSoon.ts?vue&type=script&lang=js&external"
export * from "./comingSoon.ts?vue&type=script&lang=js&external"
import style0 from "./comingSoon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports